import classnames from "classnames";
import React, { useContext } from "react";
import {
  RicosAlignmentContext,
  RicosDirectionHandledContextProvider,
  RicosNodeContext,
  RicosNodeContextProvider,
  RicosViewerContext,
  VisibleIndentationContext
} from "./../../../../../ricos-context/index.js";
import { TextStyle_TextAlignment } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import {
  Decoration_Type,
  Node_Type
} from "./../../../../../ricos-types/index.js";
import { CHECKBOX_LIST_STYLE_ATTRIBUTE_VALUE } from "./../../../../../_shared/list-checkbox/checkbox-list-style.js";
import { getBlockDefaultFontSize } from "./../../../../../_shared/list-checkbox/get-block-default-font-size.js";
import { getListSymbol, normalizeOffset } from "./../../../../../wix-rich-content-common/index.js";
import { getPaywallSeoClass, isPaywallSeo } from "../../utils/paywall-seo.js";
import { levelToClassName } from "../heading/heading.js";
import { getStartMargin } from "./get-start-margin.js";
import styles from "./lists-scss.js";
const ListItem = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const listItemNode = node;
  const { seoMode } = useContext(RicosViewerContext);
  const { parentIndex } = useContext(RicosNodeContext);
  const { visibleIndentation } = useContext(VisibleIndentationContext);
  const firstChild = node.nodes[0];
  const dataProperty = `${firstChild?.type?.toLowerCase()}Data`;
  const { textAlignment } = firstChild?.[dataProperty]?.textStyle || {};
  const { textAlignment: parentAlignment } = useContext(RicosAlignmentContext);
  const finalAlignment = textAlignment && textAlignment !== TextStyle_TextAlignment.AUTO ? textAlignment : parentAlignment;
  const listStylePosition = textAlignment && textAlignment === TextStyle_TextAlignment.CENTER;
  const { parentNode } = useContext(RicosNodeContext);
  const indentation = visibleIndentation && visibleIndentation?.nodeId === parentNode?.id ? normalizeOffset(visibleIndentation?.indentation) : 0;
  const marginInlineStart = getStartMargin(parentNode, visibleIndentation?.indentation || 0);
  const isCheckboxList = parentNode?.type === Node_Type.CHECKBOX_LIST;
  const marker = isCheckboxList ? "none" : parentNode ? getListSymbol(indentation, parentNode.type) : "";
  const isParentOfHeading = firstChild?.type === Node_Type.HEADING;
  const headingLevel = isParentOfHeading && firstChild.headingData?.level;
  const listItemClassName = classnames(
    styles.listItem,
    isPaywallSeo(seoMode) && getPaywallSeoClass(seoMode?.paywall || {}, nodeIndex + parentIndex)
  );
  const childFontSize = firstChild?.nodes?.[0]?.textData?.decorations?.find(
    (decoration) => decoration.type === Decoration_Type.FONT_SIZE
  )?.fontSizeData?.value;
  const shouldFitChildFont = !!childFontSize && childFontSize < getBlockDefaultFontSize(headingLevel || void 0);
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      dir: "auto",
      "aria-level": indentation + 1,
      className: listItemClassName,
      style: {
        textAlign: finalAlignment,
        fontSize: childFontSize,
        marginInlineStart,
        listStyleType: marker
      },
      ...shouldFitChildFont ? { "data-child-font-fit": "true" } : {},
      ...headingLevel ? {
        "data-heading-level": levelToClassName[headingLevel]
      } : {},
      ...listStylePosition ? { "data-list-style-position": "inside" } : {},
      ...isCheckboxList ? {
        "data-list-style": CHECKBOX_LIST_STYLE_ATTRIBUTE_VALUE,
        role: "checkbox",
        "aria-checked": listItemNode.listItemData?.checked ? "true" : "false"
      } : {}
    },
    isCheckboxList && // Viewer marker is presentational only; the actual checkbox control exists only in editing.
    /* @__PURE__ */ React.createElement(
      "span",
      {
        "aria-hidden": true,
        className: styles.checkboxInput,
        "aria-checked": listItemNode.listItemData?.checked ? "true" : "false"
      }
    ),
    /* @__PURE__ */ React.createElement(RicosDirectionHandledContextProvider, { directionHandled: true }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [], shouldParagraphApplyTextStyle: true })))
  );
};
const ListItemRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(ListItem, { key: node.id, node, ...props });
};
var list_item_default = ListItemRenderer;
export {
  list_item_default as default
};
//# sourceMappingURL=list-item.js.map
